import {
    combineReducers,
    createStore,
} from 'redux';

import {
    reducer as form,
} from 'redux-form';

import shop from 'components/shop/reducers';

class RootStore {
    static getStore = () => {
        if (window.ROOT_STORE) {
            return window.ROOT_STORE;
        }

        const reducers = combineReducers({
            shop,
            form,
        });

        window.ROOT_STORE = createStore(reducers);

        return RootStore.getStore();
    };
}

export default RootStore;



// WEBPACK FOOTER //
// ./resources/RootStore.js